// Earliest year a DATED registration could be on a car, from the mark alone.
// Dateless and Northern Ireland marks carry no year (null).
//
//   current  AB12 CDE  -> 2012 (March); 62 -> 2012 (September)
//   prefix   A123 BCD  -> A = 1983 ... Y = 2001
//   suffix   ABC 123A  -> A = 1963 ... Y = 1982

const PREFIX_YEARS: { [l: string]: number } = {
  A: 1983, B: 1984, C: 1985, D: 1986, E: 1987, F: 1988, G: 1989, H: 1990,
  J: 1991, K: 1992, L: 1993, M: 1994, N: 1995, P: 1996, R: 1997, S: 1998,
  T: 1999, V: 1999, W: 2000, X: 2000, Y: 2001,
};

const SUFFIX_YEARS: { [l: string]: number } = {
  A: 1963, B: 1964, C: 1965, D: 1966, E: 1967, F: 1967, G: 1968, H: 1969,
  J: 1970, K: 1971, L: 1972, M: 1973, N: 1974, P: 1975, R: 1976, S: 1977,
  T: 1978, V: 1979, W: 1980, X: 1981, Y: 1982,
};

export function datedPlateYear(registration: string | null | undefined): number | null {
  const r = (registration || '').toUpperCase().replace(/\s+/g, '');

  const current = /^[A-Z]{2}(\d{2})[A-Z]{3}$/.exec(r);
  if (current) {
    const n = parseInt(current[1], 10);
    if (n >= 2 && n <= 50) return 2000 + n;
    if (n >= 51) return 2000 + n - 50;
    return null;
  }

  const prefix = /^([A-Z])\d{1,3}[A-Z]{3}$/.exec(r);
  if (prefix) return PREFIX_YEARS[prefix[1]] || null;

  const suffix = /^[A-Z]{3}\d{1,3}([A-Z])$/.exec(r);
  if (suffix) return SUFFIX_YEARS[suffix[1]] || null;

  return null;
}

// Year a DATELESS series was introduced, from the mark's own pattern (the
// plate data reports 1903 for every dateless mark):
//   1-2 letters then digits   (D 88, AB 1234)   -> 1903
//   3 letters then digits     (ABC 123)         -> 1932 (July)
//   digits first, reversed    (1 ABC, 1000 E)   -> 1953
export function datelessSeriesYear(registration: string | null | undefined): number | null {
  const r = (registration || '').toUpperCase().replace(/\s+/g, '');
  if (/^[A-Z]{1,2}\d{1,4}$/.test(r)) return 1903;
  if (/^[A-Z]{3}\d{1,4}$/.test(r)) return 1932;
  if (/^\d{1,4}[A-Z]{1,3}$/.test(r)) return 1953;
  return null;
}
